import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { Text } from '@n26/nxd'
import { useOkta } from './OktaContext'
import { AuthLayout } from './AuthLayout'
import { ROUTES } from '@/shared/routes'

export const LoginCallbackPage = () => {
  const { oktaAuth } = useOkta()
  const navigate = useNavigate()
  const [error, setError] = useState<Error | null>(null)
  const hasHandledRedirect = useRef(false)

  useEffect(() => {
    if (hasHandledRedirect.current) return
    hasHandledRedirect.current = true

    oktaAuth
      .handleLoginRedirect()
      .then(() => navigate(ROUTES.HOME, { replace: true }))
      .catch(setError)
  }, [oktaAuth, navigate])

  return (
    <AuthLayout>
      <Text variant='small'>{error ? error.message : 'Logging in…'}</Text>
    </AuthLayout>
  )
}
